import { fetchProductGroupsForProducts } from '@lib/data/custom-store-api'
import { BHSpinner } from '@modules/bh/components'
import { useEffect, useState } from 'react'
import ProductPurchasableGate from '../product-visibility-gate'
import BHRequireAccount from '../require-account'

interface ProductRestrictionsProps {
  productId: MedusaID
  displayMessage?: boolean
  messageSize?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'
  children: React.ReactNode
}

function ProductRestrictions({
  productId,
  displayMessage = false,
  messageSize = 'p',
  children,
}: ProductRestrictionsProps) {
  const [productRestrictionData, setProductRestrictionData] =
    useState<Maybe<ProductRestrictionData>>(null)
  const [isLoading, setIsLoading] = useState(true)

  async function fetchProductRestrictions(productId: MedusaID) {
    // Additionally, fetch all product groups for the list of products
    const response = await fetchProductGroupsForProducts([productId])

    const productRestrictionData: ProductRestrictionData = {
      id: productId,
      productVisibilityGroups: response[productId],
    }

    return productRestrictionData
  }

  useEffect(() => {
    ;(async () => {
      setIsLoading(true)
      try {
        const data = await fetchProductRestrictions(productId)
        setProductRestrictionData(data)
      } catch (e) {
        console.error(e)
      } finally {
        setIsLoading(false)
      }
    })()
  }, [productId])

  if (isLoading || productRestrictionData === null) {
    return <BHSpinner active />
  }

  return (
    // First ensure customer is logged in
    <BHRequireAccount
      noAuthFallback={<div>Log in for price</div>}
      pendingApprovalFallback={
        <div>Pricing available upon account approval</div>
      }
    >
      {/* Then ensure that if the product is in a restricted group, the customer
      has access to that group */}
      <ProductPurchasableGate
        displayMessage={displayMessage}
        messageSize={messageSize}
        productRestrictionData={productRestrictionData}
      >
        {children}
      </ProductPurchasableGate>
    </BHRequireAccount>
  )
}

export default ProductRestrictions
